import { mutationOptions } from "@tanstack/react-query";

import { api } from "@platform/core/api";
import { queryClient } from "@platform/core/query";
import type { CommunicationStatus } from "./communications.types";

// Staff open/close a message. Invalidates every kind's list so the row's status
// (and the empty/closed views) refresh.
export const setCommunicationStatusMutation = mutationOptions({
	mutationFn: (vars: { id: string; status: CommunicationStatus }) =>
		api.post(`/platform/communication/${vars.id}/status`, { status: vars.status }),
	onSuccess: () => queryClient.invalidateQueries({ queryKey: ["admin", "communications"] }),
});
